import { render, staticRenderFns } from "./ChatAvatar.vue?vue&type=template&id=c2f4147c&scoped=true"
import script from "./ChatAvatar.vue?vue&type=script&lang=js"
export * from "./ChatAvatar.vue?vue&type=script&lang=js"
import style0 from "./ChatAvatar.vue?vue&type=style&index=0&id=c2f4147c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f4147c",
  null
  
)

export default component.exports